
















































































































































































































































































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    componentDataType
} from "../types";
import {
    API_URL
} from "../global";
import axios from "axios";
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { globalToLocalURL } from "../utils/common";

const DEFAULT_JOBAPP_FORM = {
    full_name: "",
    email: "",
    mobile: "",
    gender: null,
    date_of_birth: null,
    image: null,
    degree_level: null,
    degree_name: "",
    major: "",
    result: "",
    institute: "",
    year_of_experience: null,
    company_name: "",
    designation: "",
    duration: "",
    current_salary: null,
    expected_salary: null,
    cv: null,
    job: null
};
@Component({
    name: "JobApplication",
    components: {
        Datepicker,
        ValidationObserver,
        ValidationProvider,
    }
})
export default class JobApplication extends Vue {
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    public jobappform: any = JSON.parse(JSON.stringify(DEFAULT_JOBAPP_FORM));
    submitted: boolean = false;
    submitSuccess: boolean = false;
    globalToLocalURL: any = globalToLocalURL;
    public data() {
        return {
            formtitle: [],
            genders: ['male', 'female', 'other'],
            degrees: [
                { value: "msc", label: "M.Sc"},
                { value: "ma", label: "M.A"},
                { value: "bba", label: "BBA"},
                { value: "bsc", label: "B.Sc"},
                { value: "ba", label: "B.A"},
                { value: "bcom", label: "B.Com"},
                { value: "hsc", label: "H.S.C"},
                { value: "ssc", label: "S.S.C"}

            ],
            // degrees: [{
            //         "val": "bsc",
            //         "name": "B.Sc"
            //     },
            //     {
            //         "val": "msc",
            //         "name": "M.Sc"
            //     },
            //     {
            //         "val": "ma",
            //         "name": "M.A"
            //     },
            //     {
            //         "val": "ba",
            //         "name": "B.A"
            //     },
            //     {
            //         "val": "bcom",
            //         "name": "B.Com"
            //     },
            //     {
            //         "val": "hsc",
            //         "name": "H.S.C"
            //     },
            //     {
            //         "val": "ssc",
            //         "name": "S.S.C"
            //     }

            // ],
            gender: '',
            degree_level: ''
        }
    }
    // onChangeFileUpload() {
    //     this.file = this.$refs.file.files[0];
    // }
    get compURL(){
        return globalToLocalURL(this.pageData.meta.html_url + 'complete');
    }
    resetForm() {
        this.jobappform = JSON.parse(JSON.stringify(DEFAULT_JOBAPP_FORM));
    }
    public submitForm() {
          (this as any).$refs.observer.validate().then((valid: any) => {
            const data = JSON.parse(JSON.stringify(this.jobappform));
            data.job = this.pageData.id;
            //console.log(data);
            const formData = new FormData();
           // console.log(this.$refs.cv.files.length, this.$refs.image.files.length)
            if ((this as any).$refs.cv.files.length && (this as any).$refs.image.files.length) {
                Object.keys(data).map((key: string) => {
                    if (["cv", "image"].indexOf(key) == -1){
                        if (key == "date_of_birth"){
                        formData.append(key, moment(data[key]).format('YYYY-MM-DD'));
                        } else {
                            formData.append(key, data[key]);
                        }
                    }
                });
                formData.append("cv", (this.$refs.cv as any).files[0]);
                formData.append("image", (this.$refs.image as any).files[0]);
                axios
                    .post(`${API_URL}/jobapplication-form/`, formData)
                    .then((resp: any) => {
                        this.submitted = true;
                        this.submitSuccess = true;
                        (this as any).$router.push(this.compURL)
                    })
                    .catch((err: any) => {
                        this.submitted = true;
                    });

                }
          });
    }

    // public submitForm() {
    //     this.$validator.validate().then(() => {
    //       console.log(this.errors);

    //       if (this.errors.items.length == 0) {
    //         const data = JSON.parse(JSON.stringify(this.applicationData));
    //         data.job = this.pageData.id;
    //         const formData = new FormData();
    //         if (this.$refs.cv) {
    //           formData.append("cv", (this.$refs!.cv as any).files[0]);
    //           Object.keys(data).map((key: string) => {
    //             formData.append(key, data[key]);
    //           });
    //           axios
    //             .post(`${API_URL}/others/apply/`, formData, {
    //               headers: {
    //                 "Content-Type": "multipart/form-data"
    //               }
    //             })
    //             .then(resp => {
    //               this.submitted = true;
    //             });
    //         }
    //       }

    public created() {

        axios.get(`${API_URL}/others/settings/global-settings/`)
            .then(response => {
                (this as any).formtitle = response.data
            })
            .catch(e => {
                (this as any).errors.push(e)
            })

    }

}
